/**
 * Persist access token in localStorage so the user stays logged in across
 * tabs, browser restarts, and page refreshes (until they log out or token expires).
 */
const AUTH_TOKEN_KEY = 'torgyd_access_token';

export const getStoredToken = () => localStorage.getItem(AUTH_TOKEN_KEY);
export const setStoredToken = (token) => {
	if (token) localStorage.setItem(AUTH_TOKEN_KEY, token);
	else localStorage.removeItem(AUTH_TOKEN_KEY);
};
export const removeStoredToken = () => localStorage.removeItem(AUTH_TOKEN_KEY);
